import React from "react"
import { Text } from "@chakra-ui/react"
import Link from "components/elements/Link"
import useGuestsStore from "services/useGuestsStore"

type Props = {
  onClick: () => void
  fontSize?: string
}

const SelectAllLink = ({ onClick, fontSize }: Props) => {
  const selectAllBlocked = useGuestsStore((s) => s.selectAllBlocked)

  if (selectAllBlocked) {
    return <Text as="span" fontSize={fontSize} color="gray.400" cursor="not-allowed" aria-disabled="true">select all</Text>
  }

  return <Link fontSize={fontSize} onClick={onClick}>select all</Link>
}

export default SelectAllLink
